module.exports = __webpack_public_path__ + "img/architectural-elements-2.f423ed12.jpeg";